// Small session-scoped store used to remember the ordered list of listing IDs
// the user was viewing (Browse, MyListings, Watchlist, PublicProfile). The
// ListingDetail page reads this to render Prev / Next controls so users can
// step through cards without popping back to the browse grid.

const KEY = "hunt57.browseContext.v1";

export function saveBrowseContext(ids, label = "browse") {
  try {
    const clean = (ids || []).filter(Boolean);
    if (!clean.length) return;
    sessionStorage.setItem(KEY, JSON.stringify({ ids: clean, label, ts: Date.now() }));
  } catch { /* sessionStorage may be unavailable — ignore */ }
}

export function getBrowseContext() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const ctx = JSON.parse(raw);
    if (!ctx?.ids?.length) return null;
    return ctx;
  } catch { return null; }
}

export function neighborsOf(id) {
  const ctx = getBrowseContext();
  if (!ctx) return { prev: null, next: null, index: -1, total: 0, label: null };
  const idx = ctx.ids.indexOf(id);
  if (idx === -1) return { prev: null, next: null, index: -1, total: ctx.ids.length, label: ctx.label };
  return {
    prev: idx > 0 ? ctx.ids[idx - 1] : null,
    next: idx < ctx.ids.length - 1 ? ctx.ids[idx + 1] : null,
    index: idx,
    total: ctx.ids.length,
    label: ctx.label,
  };
}
